import { render } from "./footBar.vue?vue&type=template&id=471291a0"
import script from "./footBar.vue?vue&type=script&lang=js"
export * from "./footBar.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__